
import * as types from "./types";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { AccountService } from "../../services/account.service";
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import router from '../../../../router';

const NavTabModule = getNavTabModule(types.DistributionAccountDetails, 'distributionAccountDetails');
export const distributionAccountActions = {
  async [types.AccountList.SET.ALL]({ commit, getters }, payload) {
    commit(types.AccountList.SET.ALL, {
      ...getters.AccountList,
      accounts: payload
    });
  },

  async [types.AccountDistributionData.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const accountDistributionDataRes = await AccountService.getAccountList();
    console.log({'actions.js:21 accountDistributionDataRes' : accountDistributionDataRes.data});

    commit(types.AccountDistributionData.SET.SINGLE, accountDistributionDataRes.data);
  },
  async [types.AccountList.FETCH.ALL]({ commit, getters, state }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;

    let res;
    console.log('row_count',row_count,start);
    if (searchMode == 'none') {
      if (start == 0) {
        res = await AccountService.getAccounts(start);
        console.log('start',res);
        commit(types.AccountList.SET.ALL, { accounts: res?.data?.accounts });
      } else {
        res = await AccountService.getAccounts(start);
        console.log('b',getters);
        commit(types.AccountList.SET.ALL, {
          ...getters.accountList,
          accounts: [
            ...getters.accountList?.accounts,
            ...res.data.accounts,
          ]
        });

        // Setting EOL
        if (!(res?.data?.accounts?.length > 0)) {
          return EOL_REACHED;
        }
      }

    } 
    
    else if (searchMode == 'basic') {
      const { searchString, channel, accountTypes } = basicFilter;

      res = await AccountService.getFilteredAccountList(searchString, channel, accountTypes);
      console.log('c');
      if (start == 0) {
        commit(types.AccountList.SET.ALL, {
          ...getters.AccountList,
          accounts: res.data.accounts
        });
      } else {
        commit(types.AccountList.SET.ALL, {
          ...getters.AccountList,
          accounts: [
            ...getters.AccountList.accounts,
            ...res.data.accounts
          ]
        });
      }


      // Setting EOL
      if (!(res?.data?.length > 0)) {
        return EOL_REACHED;
      }
    }

  },
  async [types.AccountList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { kVal, name, value } = payload

    commit(types.AccountList.UPDATE.SINGLE, payload)
    await MHTTPCL.modify(undefined, kVal, name, value, "l_accounts");

  },
  async [types.AccountList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { account_id } = payload;
    const nextAccountsList = await AccountService.deleteAccount(account_id);
    commit(types.AccountList.DELETE.SINGLE, payload);
  },
  // Show Sidewindow
  async [types.DistributionAccountDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, account, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "account_id";
    const itemName = "account";
    const item = payload[itemName];
    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "distributionAccountDetails";
    const DetailsAction = types.DistributionAccountDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });


    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      AccountService.getAccountTabOrders(account.account_id),
      AccountService.getAccountTabCOST(account.account_id),
      AccountService.getAccountTabSetup(account.account_id),
      AccountService.getAccountTabOverview(account.account_id),
      AccountService.getAccountTabCatalogue(account.account_id),
      AccountService.getAccountTabStatementHistory(account.account_id),
      AccountService.getAccountTabCurrentStatement(account.account_id),
    ]);
    console.log("detailsData", detailsData);

    // DBox
    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, account) => {
        return {
          ...account,
          ...detailsData,
          loading: false,

        };
      }
    );
  },
  // Left NavItem child details
  ...NavTabModule.implementActions(
    "account_id",
    "accounts/account_id/tab",
    "accounts",
    () => router,
    "distribution",
    (value, key) => {
      const { account } = value;
      console.log('value', value);
      return {
        title:
          value && value.account && value.account.account_name
            ? value.account.account_name
            : key,
        full_title:
          value && value.account && value.account.account_name
            ? value.account.account_name
            : key
      };
    }
  ),

  
  async [types.DistributionAccountDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item } = payload
    const { account } = item;
    const { account_id } = account;


    console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(account_id, (distributionAccountDetails) => {
      return {
        account: {
          ...distributionAccountDetails.account,
          [name]: value,
        }
      }
    });
    
    const modifiedItem = await MHTTPCL.modifyJSON('account_id', account_id, name, value, 'l_accounts')
    

    // After Sidewindow Modification Here comes the List Modification - 

    if (['status_id'].includes(name)) {
      commit(types.AccountList.UPDATE.SINGLE, {
        kVal: account_id,
        name,
        value
      })
    }






  },

  
  async [types.DistributionAccountRelatedContacts.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const { name, value, item, selectedAccountsDetails } = payload;
    const { account } = selectedAccountsDetails
    const { account_id } = account;

    const key = 'contact_relation_id';
    const kVal = item[key];
    const table = 'contact_relations';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }


    NavTabHelper.updateSingleNavTabDetails(account_id, (selectedAccountsDetails) => {
      return {
        contact_relations: selectedAccountsDetails.contact_relations.map(e => {
          if (e.contact_relation_id == item.contact_relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    })

    const modifiedRelease = await MHTTPCL.modifyJSON(key, kVal, name, value, table)

  },

  async [types.DistributionAccountRelatedContacts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { contact, selectedAccountsDetails } = payload;
    const { account } = selectedAccountsDetails
    const { account_id } = account;
    const { contact_relation_id } = contact;

    NavTabHelper.updateSingleNavTabDetails(account_id, selectedAccountsDetails => {
      return {

        contact_relations: selectedAccountsDetails.contact_relations.
          filter(e => e.contact_relation_id != contact_relation_id)
      }
    });

     const deletedContact = await AccountService.deleteRelation(contact_relation_id);


  },


  async [types.DistributionAccountRelatedContacts.SET.ALL]({ commit, getters, dispatch }, {
    contact_relations,
    external_table,
    external_id,
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(external_id, (_, selectedAccountsDetails) => {
      return {
        ...selectedAccountsDetails,
        contact_relations: contact_relations
      };
    })
  },

  async [types.SET_DISTRIBUTION_ACCOUNT_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const account_id = externalId;
    NavTabHelper.setSingleNavTabDetails(account_id, (_, selectedAccountsDetails) => {
      return {
        ...selectedAccountsDetails,
        files: files,
      }
    });
  },

  async [types.DistributionAccountInvoiceContact.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("payload",payload)

    const { external_id ,item_contact } =payload;

    NavTabHelper.updateSingleNavTabDetails(external_id, (_, selectedAccountsDetails) => {
      return {
        ...selectedAccountsDetails,
        invoice_contact: item_contact
      };
    })
  },

  async [types.DistributionAccountDeliveryAddress.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("payload",payload)

    const { external_id ,item_contact } =payload;

    NavTabHelper.updateSingleNavTabDetails(external_id, (_, selectedAccountsDetails) => {
      return {
        ...selectedAccountsDetails,
        delivery_contact: item_contact
      };
    })
  },



  async [types.DistributionOrderList.SET.ALL]({ commit, getters, dispatch }, {
    orders,
    account_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        orders: orders
      };
    })
  },
  async [types.DistributionAccountBackOrder.SET.ALL]({ commit, getters, dispatch }, {
    backorders,
    account_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        backorders: backorders
      };
    })
  },
  async [types.DistributionCatalogueLabels.SET.ALL]({ commit, getters, dispatch }, {
    label_accounts,
    account_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        label_accounts: label_accounts
      };
    })
  },
  async [types.DistributionCatalogueAccount.SET.ALL]({ commit, getters, dispatch }, {
    product_accounts,
    account_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        product_accounts: product_accounts
      };
    })
  },


  async [types.DistributionAccountCurrentStatements.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item ,  account_id} =payload;

    const { statement_id } = item;

    
    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        current_statements:accountsDetailsObj.current_statements.filter(e=>e.statement_id!=statement_id)
      };
    });

    await AccountService.deleteCurrentStatement({statement_id});

    // const modifiedOrder =await OrderService.modifyOrder(order_id,name,value,'l_orders');
  },

  async [types.DistributionAccountCurrentStatements.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { account_id} =payload;

    const resData= await AccountService.insertCurrentStatement({...payload});

    //console.log(resData,":::::::::::::::");


    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        current_statements:[...resData.data.statements]
      };
    });
    // const modifiedOrder =await OrderService.modifyOrder(order_id,name,value,'l_orders');
  },
  async [types.DISTRIBUTION_ACCOUNT_SET_MULTIPLE_STATEMENTS_INVOICE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { ids, account_id} =payload;

    const resData= await AccountService.setAccountonMultipleInvoice(account_id,[...ids]);

    console.log(resData,":::::::::::::::");


    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        current_statements:[...resData.data.statements]
      };
    });
    // const modifiedOrder =await OrderService.modifyOrder(order_id,name,value,'l_orders');


    return resData.data.invoice
  },
  async [types.DISTRIBUTION_ACCOUNT_SET_STATEMENTS_INVOICE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::DISTRIBUTION_ACCOUNT_SET_STATEMENTS_INVOICE",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { ids, account_id} =payload;

    const resData= await AccountService.createSetStatementsInvoice(account_id,[...ids], payload.royalty_date1);

    const process = resData.data.process;
    
    if(process === 'next'){
      AccountService.createBigStatementsSales(account_id,[...ids], payload.royalty_date1);
    }

    console.log(resData,":::::::::::::::",process);


    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        current_statements:[...resData.data.statements]
      };
    });
    // const modifiedOrder =await OrderService.modifyOrder(order_id,name,value,'l_orders');


    return { invoice:resData.data.invoice , process:process}
  },

  async [types.DistributionAccountImportSetup.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { account_id } =payload;

    const resData= await AccountService.newEditStmtSettings(payload);

    const newList =await AccountService.accountStmtSettingsList(account_id);
   // console.log(resData,":::::::::::::::");


    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        statement_settings:[...newList.data.statement_settings]
      };
    });

  },
  async [types.DistributionAccountImportSetup.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name ,value , kVal ,account_id} =payload;



    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
     
      return {
        ...accountsDetailsObj,
        statement_settings:accountsDetailsObj.statement_settings.map(e=>{

          if(e.statement_setting_id==kVal){
            return{
              ...e,
              [name]:value
            }
          }else{
            return e
          }
        })
      };
    });
    
    const modifiedOrder =await MHTTPCL.modify(undefined,kVal,name,value,'l_statement_settings');
  },

  async [types.DistributionAccountImportSetup.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { statement_setting_id ,account_id } =payload;

    //const resData= await AccountService.createSetStatementsInvoice(account_id,[...ids]);

   // console.log(resData,":::::::::::::::");


    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        statement_settings:accountsDetailsObj.statement_settings.filter(e=>e.statement_setting_id!=statement_setting_id)
      };
    });
    
    const modifiedOrder =await AccountService.deleteStatementSetting({statement_setting_id});
  },

  async [types.DistributionAccountDiscount.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { account_id ,name ,value ,kVal ,key} =payload;
   // console.log(resData,":::::::::::::::");


    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        account_pricecodes:accountsDetailsObj.account_pricecodes.map(x=>{
          if(x.account_pricecode_id==kVal){
            return{
              ...x,
              [name]:value
            }
          }
          else {
            return x;
          }
        })
      };
    });

    await MHTTPCL.modifyJSON(key,kVal,name,value,'l_account_pricecodes')
    
  },

  async [types.DistributionAccountDiscount.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { account_id ,item} =payload;
    const { account_pricecode_id } = item;
   // console.log(resData,":::::::::::::::");


    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        account_pricecodes:accountsDetailsObj.account_pricecodes.filter(x=>x.account_pricecode_id!=account_pricecode_id)
      };
    });

    await AccountService.deleteAccountDiscount({account_pricecode_id});
    
  },

  async [types.DistributionAccountDiscount.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { account_id } =payload;
   // console.log(resData,":::::::::::::::");

   const resData = await AccountService.addDiscountPricecode({account_id}); 
   console.log(resData,":::::::::::::::");
    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        account_pricecodes:[...resData.data.account_pricecodes]
      };
    });

    
    
  },

  async [types.DistributionAccountManualMatch.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(":::::::::::::::::::::",payload);


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { account_id ,item} =payload;
    const { relation_id } = item;
   // console.log(resData,":::::::::::::::");


    NavTabHelper.updateSingleNavTabDetails(account_id, (accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        relations:accountsDetailsObj.relations.filter(x=>x.relation_id!=relation_id)
      };
    });

   await AccountService.deleteAccountRelation({relation_id});
   
  },


}
